import React from 'react';
import { ChildrenPropType } from '../../../../types/component';
var defaultProps = {};
export default function Condition(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
Condition.defaultProps = defaultProps;